import React from 'react';
import { UserX, Clock, Brain } from 'lucide-react';

const Problem = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            What's the point of meeting people...
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            if you can't remember them next week?
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <UserX className="w-8 h-8 text-red-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Lost Connections</h3>
            <p className="text-gray-600 leading-relaxed">
              You meet someone interesting at an event, exchange business cards, and then... nothing. 
              Their card gets lost in the stack, and the opportunity fades away.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Clock className="w-8 h-8 text-orange-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Poor Timing</h3>
            <p className="text-gray-600 leading-relaxed">
              When you finally remember to follow up, it's been so long that reaching out feels awkward. 
              The moment has passed, and the connection feels forced.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Brain className="w-8 h-8 text-purple-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Missing Context</h3>
            <p className="text-gray-600 leading-relaxed">
              Even if you have their contact info, you can't remember what you talked about, 
              where you met, or why the connection was valuable in the first place.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            The average professional meets 1,000+ new people per year
          </h3>
          <p className="text-lg text-gray-600 mb-6">
            But only maintains meaningful relationships with less than 5% of them
          </p>
          <div className="inline-flex items-center bg-blue-50 text-blue-800 px-6 py-3 rounded-full text-sm font-medium">
            <span className="w-2 h-2 bg-blue-600 rounded-full mr-3"></span>
            95% of networking potential is wasted
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;